import {Component} from '@angular/core';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';
/**
 * Rc Checkbox Component - designed checkbox
 *
 * @example
 * <lib-rc-checkbox
 * [control]="myFormControl"
 * [disabled]="isDisabled"
 * [elementId]="'myCheckboxElementID'"
 * (valueChangedCallback)="checkboxChanged($event)"
 * [errorMsg]="errorMsg">
 *    approve email
 * </lib-rc-checkbox>
 *
 */
@Component({
    selector: 'lib-rc-checkbox',
    template: `<div class="rc-form-checkbox {{className}}">
  <label class="custom-control custom-checkbox" [for]="elementId">
    <input (change)="onChange()" type="checkbox" class="custom-control-input" [formControl]="control" [id]="elementId" [attr.disabled]="_disabled"
           attr.aria-label="{{ariaLabel}}"
           attr.aria-labeledby="{{ariaLabeledBy}}"
           attr.aria-describedby="{{getAriaDescribedBy()}}"
    >
    <span class="custom-control-indicator"></span>
    <span class="custom-control-description">
      <ng-content></ng-content>
    </span>
  </label>
</div>
<div role="alert" id="{{errorElementId}}" class="invalid-feedback-message" *ngIf="errorMsg">{{ errorMsg }}</div>`,
    styles: [``]
})
export class RcCheckboxComponent extends RcFormControlAbstract {

}
